import * as React from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui";
import { HoloBorder } from "@/components/Holo";
import { PersonalizedPostsHelpDialog } from "./help/PersonalizedPostsHelpDialog";

export const INTRO_DISMISSED_KEY = "sharePostIntroDismissed";

function readDismissed(): boolean {
  try {
    return typeof window !== "undefined" && window.localStorage.getItem(INTRO_DISMISSED_KEY) != null;
  } catch {
    return false;
  }
}

/** A one-time introduction to personalized prompts above the player's library. */
export const PlayerIntroCard: React.FC = () => {
  const [dismissed, setDismissed] = React.useState(readDismissed);
  const [helpOpen, setHelpOpen] = React.useState(false);
  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      window.localStorage.setItem(INTRO_DISMISSED_KEY, "true");
    } catch {
      // Without storage it simply shows again next time.
    }
  };

  return (
    <>
      <HoloBorder active={false} radius="2xl" className="mb-4">
        <div className="relative flex flex-col gap-2 rounded-2xl bg-white p-5 pr-12" data-testid="player-intro-card">
          <div className="text-lg font-bold text-slate-900">Turn client reviews into branded posts</div>
          <p className="text-base text-slate-600">
            Personalized designs use your name, photo, and branding. Pick a look, pick a review, and your post is built
            for you.
          </p>
          <div>
            <Button variant="link" size="sm" className="px-0" onClick={() => setHelpOpen(true)}>
              How personalized posts work
            </Button>
          </div>
          <Button
            size="icon-xs"
            variant="ghost"
            aria-label="Dismiss"
            className="absolute top-3 right-3"
            onClick={dismiss}
          >
            <X />
          </Button>
        </div>
      </HoloBorder>
      <PersonalizedPostsHelpDialog open={helpOpen} onOpenChange={setHelpOpen} />
    </>
  );
};
